// Shared chat utility functions for marketplace messaging
// Re-exports the canonical utilities from common formatting

import { groupMessages, MessageGroup } from '@/utils/residents/messages/groupMessages';
import {
  formatMessageTime as formatMessageTimeCommon,
  formatChatDate,
} from '@/utils/common/formatting';

// Re-export types
export type { MessageGroup };

/**
 * Format a timestamp to a time string (e.g., "3:16 PM")
 * @deprecated Use formatMessageTime from '@/utils/common/formatting' instead
 */
export const formatTime = formatMessageTimeCommon;

/**
 * Format a timestamp to a date string (e.g., "Aug 15, 2024")
 * @deprecated Use formatChatDate from '@/utils/common/formatting' instead
 */
export const formatDate = formatChatDate;

/**
 * Group messages by date for display with date separators.
 * This is a convenience wrapper around the shared groupMessages utility
 * for marketplace messages that use the 'timestamp' field.
 */
export const groupMessagesByDate = <T extends { timestamp: Date | string }>(
  messages: T[]
): MessageGroup<T>[] => {
  return groupMessages(messages, {
    getHeaderDate: (msg) => formatChatDate(msg.timestamp),
    getTimestamp: (msg) => msg.timestamp,
  });
};
